<!--
 * @Description: 
 * @Author: pliybird
 * @Date: 2023-06-07 17:54:41
 * @LastEditTime: 2023-08-02 17:34:04
 * @LastEditors: pliybird
 * @filePath: Do not edit
-->
<template>
  <div class="product-ability rn-section-gap">
    <SectionTitle
      :title="$t('product.product_features')"
      description="PRODUCT FEATURES"
      textAlign="center"
    />
    <div class="container">
      <div
        class="ability-content row p-4 gx-0 gx-lg-5 gx-md-5"
        v-for="(item, index) in abilityData"
        :key="index"
        :class="getContentRight(index)"
      >
        <div
          class="numImg_and_text col-lg-5 col-md-5 col-sm-12 col-12 p-4 gx-5"
        >
          <img
            :src="item.numImage"
            alt=""
            class="num-image"
            :class="getImageRight(index)"
          />
          <div class="content-text">
            <div class="text-title">{{ item.title }}</div>
            <div
              :class="{ text: item.text }"
              v-if="typeof item.text != 'object'"
            >
              {{ item.text }}
            </div>
            <div
              class="text-more"
              v-else
              v-for="(textItem, textIndex) in item.text"
              :key="textIndex"
            >
              <span
                class="text-more-subtitle"
                v-if="textItem.subtitle && textItem.subtitle !== ''"
                >{{ textItem.subtitle }}</span
              >
              <span
                class="text-more-subtext"
                v-if="textItem.subtext && textItem.subtext !== ''"
                >{{ textItem.subtext }}</span
              >
            </div>
          </div>
        </div>
        <div class="content-image  col-lg-5 col-md-5 col-sm-12 col-12 p-0 gx-5" :class="{'water-mark':abilityType !='loyalty'}" :data-content="$t('product.example')"  v-if="typeof item.contentImage != 'object'">

          <img
            
            :src="item.contentImage"
           
          />
        </div>

        <div
          class="content-image-LTCbox col-lg-7 col-md-7 col-sm-12 col-12 p-4 gx-5"
          v-if="abilityType == 'LTC' && typeof item.contentImage === 'object'"
        >
          <div
            v-for="(imageItem, imageIndex) in item.contentImage"
            :key="imageIndex"
            class="content-image-container water-mark" :data-content="$t('product.example')"
          >
            <img class="content-image-more" :src="imageItem" />
          </div>
        </div>

        <div
          class="content-image-box col-lg-5 col-md-5 col-sm-12 col-12 p-0 p-lg-4 p-md-4 gx-5"
          v-if="abilityType == 'FCST' && typeof item.contentImage === 'object'"
        >
        <div class="content-image water-mark" :data-content="$t('product.example')">

          <img
           
            :src="item.contentImage[0]"
          />
        </div>
        <div class="content-image water-mark content-image-second" :data-content="$t('product.example')">
          <img
            :src="item.contentImage[1]"
          />
        </div>
         
        </div>

        <div
          class="content-image-box col-lg-7 col-md-7 col-sm-12 col-12 p-0 p-lg-4 p-md-4 gx-5"
          v-if="
            abilityType == 'Workflow' && typeof item.contentImage === 'object'
          "
        >
          <div class="left">
            <div v-for="(ite, index) in item.contentImage.slice(0,4)" :key="index" class="content-bg-img water-mark" :data-content="$t('product.example')">
              <img class="content-img" :src="ite" />
            </div>
          </div>
          <div class="right">
            <div v-for="(ite, index) in item.contentImage.slice(4,8)" :key="index" class="content-bg-img water-mark" :data-content="$t('product.example')">
              <img class="content-img" :src="ite" />
            </div>
          </div>
          <!-- <div class="row"> -->
            
            
            <!-- <div v-for="(ite, index) in item.contentImage" :key="index" class="content-bg-img-position">
              <img class="content-bg-img" :src="require('@/assets/images/ProductService/common/phone_bg.png')"/>
              <img class="content-img" :src="ite" />
            </div> -->
          <!-- </div> -->
          <!-- <img
            class="content-image content-image-first"
            :src="item.contentImage[0]"
          />
          <img
            class="content-image content-image-second"
            :src="item.contentImage[1]"
          /> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SectionTitle from '../../../components/elements/sectionTitle/SectionTitle.vue'

export default {
  name: 'ProductAbility',
  components: { SectionTitle },
  props: {
    'abilityData': {
      type: Array,
      default: [],
    },
    'abilityType': {
      type: String,
      default: '',
    },
  },
  computed: {
    getContentRight () {
      return (index) => {
        return index % 2 === 0 ? '' : 'abilityContentRight';
      };
    },
    getImageRight () {
      return (index) => {
        return index % 2 === 0 ? 'numImageLeft' : 'numImageRight';
      };
    },
  },
  data () {
    return {
      startIndex: 2,
    }
  },
  methods: {
    
  }
}
</script>